import axios from '../../axios';

export default {
  namespaced: true,
  state: {
    allCurrencies: null,
    paymentCurrencyIds: [1, 3, 10] /* EURO, USD, GBP */,
    currentCurrencyId: null,
  },
  getters: {
    getAllcurrencies: (state) => {
      if (state.allCurrencies) {
        return state.allCurrencies;
      }
    },
    paymentCurrencies: (state, getters) => {
      let paymentCurrencies = [];
      if (getters.getAllcurrencies) {
        paymentCurrencies = getters.getAllcurrencies.filter((c) => state.paymentCurrencyIds.includes(c.id));
      }
      return paymentCurrencies;
    },
    getCurrencyById: (state, getters) => (id) => {
      const all = getters.getAllcurrencies;
      if (all && all.length > 0) {
        const cur = all.find((c) => c.id === Number(id));
        if (cur !== undefined) {
          return cur;
        }
      }
    },
    getCurrentCurrency: (state, getters, rootState, rootGetters) => {
      // if user previously set a currency
      if (state.currentCurrencyId) {
        return getters.getCurrencyById(state.currentCurrencyId);
      }

      // return based on user Geo location.
      if (rootGetters['common/getOfficeStatus']) {
        const country = rootGetters['common/getOfficeStatus'].countryCode;
        if (country === 'gb') {
          return getters.getCurrencyById(10);
        }
        if (country === 'us') {
          return getters.getCurrencyById(3);
        }

        // Rest of world
        return getters.getCurrencyById(1);
      }
      return getters.getCurrencyById(1);
    },
  },
  mutations: {
    setAllCurrencies(state, data) {
      state.allCurrencies = data;
    },
    setCurrentCurrencyId(state, data) {
      state.currentCurrencyId = data;
      $cookies.set('currentCurrencyId', data, '3m', null, null, false);
    },
  },
  actions: {
    // fetchAllCurrencies({ commit, dispatch, getters }) {
    //  axios.get('/core/currencies/live?$select=id,code,name,sign,rate')
    //    .then((res) => {
    //      commit('setAllCurrencies', res.data);
    //      if ($cookies.get('currentCurrencyId')) {
    //        commit('setCurrentCurrencyId', $cookies.get('currentCurrencyId'));
    //      }
    //    })
    //    .catch((error) => console.log(error));
    // },
  },
};
